import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { communicationStatus } from '~client/constants';

export default class ErrorMessage extends React.Component {
  matchErrorStatusCode = code => code === this.props.communication.errorInfo.statusCode;

  matchErrorDescription = desc => {
    if (typeof desc === 'undefined') {
      return false;
    }

    let message = this.props.communication.errorInfo.errorDescription;
    if (typeof message === 'object') {
      message = JSON.stringify(message);
    }

    return message.toLowerCase().indexOf(desc.toLowerCase()) !== -1;
  };

  render() {
    let errorMessage = null;

    if (this.props.communication.status === communicationStatus.ERROR) {
      this.props.customErrors.find(errorBody => {
        if (
          !errorMessage &&
          (this.matchErrorStatusCode(errorBody.statusCode) ||
            this.matchErrorDescription(errorBody.description))
        ) {
          errorMessage = errorBody.message;
          return true;
        }

        return false;
      });

      if (!errorMessage) {
        errorMessage = this.props.defaultErrorMessage;
      }
    }

    if (
      this.props.communication.status === communicationStatus.CLIENT_ERROR &&
      this.props.clientErrorMessage
    ) {
      errorMessage = this.props.clientErrorMessage;
    }

    if (
      this.props.communication.status === communicationStatus.TIMEOUT &&
      this.props.timeoutMessage
    ) {
      errorMessage = this.props.timeoutMessage;
    }

    if (!errorMessage) {
      return null;
    }

    if (this.props.type === 'middle') {
      return (
        <span className={classNames('try-again', this.props.className)}>
          <div className="try-again__container">
            <div className="try-again__icon" />
            <div className="try-again__summary">{errorMessage}</div>
            <button className="try-again__button button" onClick={this.props.buttonFunction}>
              {this.props.buttonText}
            </button>
          </div>
        </span>
      );
    }

    return <span className={classNames('error-bar', this.props.className)}>{errorMessage}</span>;
  }
}

ErrorMessage.propTypes = {
  className: PropTypes.string,
  communication: PropTypes.object.isRequired,
  customErrors: PropTypes.array,
  buttonText: PropTypes.string,
  buttonFunction: PropTypes.func,
  defaultErrorMessage: PropTypes.string.isRequired,
  clientErrorMessage: PropTypes.string.isRequired,
  timeoutMessage: PropTypes.string.isRequired,
  type: PropTypes.string,
};

ErrorMessage.defaultProps = {
  className: '',
  communication: {},
  customErrors: [],
  buttonText: '',
  buttonFunction: () => {},
  defaultErrorMessage: '',
  clientErrorMessage: '',
  timeoutMessage: '',
  type: 'top',
};
